<template>
  <ion-card>
    <ion-card-header>
      <ion-card-title>{{client}}</ion-card-title>
      <ion-card-subtitle>{{project.name}}</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-grid>
        <ion-row>
          <ion-col size="auto">
            <ion-label>Deliverable</ion-label>
          </ion-col>
          <ion-col>
            <ion-text>{{project.deliverable}}</ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="auto">
            <ion-label>Description</ion-label>
          </ion-col>
          <ion-col>
            <ion-text>{{project.description}}</ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</template>

<script>
import { defineComponent } from 'vue'

import { IonCard, IonCardTitle, IonCardHeader, IonCardContent, IonCardSubtitle, IonRow, IonCol, IonText, IonLabel, IonGrid} from '@ionic/vue';

export default defineComponent ({
  name: 'JobExperiences',
  props: {
    client: {
      type: String,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    IonCard, IonCardTitle, IonCardSubtitle, IonLabel, IonGrid,
    IonCardHeader, IonCardContent, IonRow, IonCol, IonText
  }
}
);

</script>

<style>
ion-text{
  font-size: 12px
}
</style>
